export default "__VITE_ASSET__xp27Q$Xt__"